import {
  SET_GAME_ENABLED,
  SET_IS_BLOCKED,
  SET_PROGRESS,
  SET_PUPSWIPE_DATA,
  SET_PUPSWIPE_ERROR,
  SET_PUPSWIPE_MORE,
  SET_PUPSWIPE_PAGE,
  SET_PUPSWIPE_STATUS,
  SET_PUPSWIPE_TUTORIAL,
  SET_TOTAL_CARDS,
  SET_WHEEL_DATA,
  SET_PUPSWIPE_CARD_REMOVE,
  SET_PUPSWIPES_COUNT,
  RESET_PUPSWIPE_WHEEL,
  SET_PUPSWIPE_MODAL,
  RESET_PUPSWIPE,
  SET_PUPSWIPE_INDICATORS,
  SET_PUPSWIPE_BLOCKED,
  SET_PUPSWIPE_TIMELEFT,
} from '../actionTypes';
import { newState } from '../utils';

const initialState = {
  data: [],
  pageToLoad: 1,
  isMore: true,
  status: 'pending',
  error: null,
  withTutorial: true,
  wheelData: {
    active: false,
    items: [],
    spottedItem: null,
    pupswipeCardId: null,
  },
  progress: 0,
  totalCards: 0,
  gameEnabled: true,
  isBlocked: false,
  swipesCount: 0,
  modalOpened: false,
  timeForNextGame: null,
  isAdCard: false,
  indicators: {
    closestAd: null,
    closestWheel: null,
    progress: null,
    slidesLeft: null,
  },
};

const pupswipeReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PUPSWIPE_DATA:
      return newState(state, {
        data: action.payload,
        error: null,
        status: 'success',
        // pageToLoad: state.pageToLoad + 1,
      });
    case SET_PUPSWIPE_CARD_REMOVE:
      return newState(state, {
        data: action.payload,
      });
    case SET_PUPSWIPE_MORE:
      return newState(state, {
        isMore: action.payload,
      });
    case SET_PUPSWIPE_STATUS:
      return newState(state, {
        status: action.payload,
      });
    case SET_PUPSWIPE_PAGE:
      return newState(state, {
        pageToLoad: action.payload,
      });
    case SET_PUPSWIPE_ERROR:
      return newState(state, {
        error: action.payload,
        status: 'error',
      });
    case SET_PUPSWIPE_TUTORIAL:
      return newState(state, {
        withTutorial: action.payload,
      });
    case SET_WHEEL_DATA:
      return newState(state, {
        wheelData: {
          ...state.wheelData,
          ...action.payload,
        },
      });
    case SET_IS_BLOCKED:
      return newState(state, {
        isBlocked: action.payload,
      });
    case SET_PROGRESS:
      return newState(state, {
        progress: action.payload,
      });
    case SET_TOTAL_CARDS:
      return newState(state, {
        totalCards: action.payload,
      });
    case SET_GAME_ENABLED:
      return newState(state, {
        gameEnabled: action.payload,
      });
    case SET_PUPSWIPE_BLOCKED:
      return newState(state, {
        isBlocked: action.payload,
      });
    case SET_PUPSWIPES_COUNT:
      return newState(state, {
        swipesCount: state.swipesCount + action.payload,
      });
    case RESET_PUPSWIPE_WHEEL:
      return newState(state, {
        swipesCount: 0,
        progress: 0,
      });
    case SET_PUPSWIPE_MODAL:
      return newState(state, {
        modalOpened: action.payload,
      });
    case SET_PUPSWIPE_INDICATORS:
      return newState(state, {
        indicators: {
          ...state.indicators,
          ...action.payload,
        },
      });
    case SET_PUPSWIPE_TIMELEFT:
      return newState(state, {
        timeForNextGame: action.payload,
      });
    case RESET_PUPSWIPE:
      return {
        ...initialState,
      };
    case 'pupswipe/setAdCard':
      return newState(state, {
        isAdCard: action.payload,
      });
    default:
      return state;
  }
};

export default pupswipeReducer;
